export default __webpack_public_path__ + "static/media/p7-11.f8dbba82.png";